import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ConfigService, PageService } from '@gallaghercp/core-frontend';

export const authRouteGuard: CanActivateFn = route => {
    const router = inject(Router);
    const pages = inject(PageService);
    const config = inject(ConfigService);
    const routePath = route.routeConfig?.path || '';

    const basePath = routePath.split('/')[0].split(':')[0];

    const allowedRoutes = [...(config.get('auth')?.routes || [])];
    if (allowedRoutes.includes('login')) {
        allowedRoutes.push('logout');
    }
    const isAllowed = allowedRoutes.includes(basePath);

    if (!isAllowed) {
        pages.pageNotFound = basePath;
        router.navigate(['/404'], { skipLocationChange: true });
        return false;
    }

    return true;
};
